import React from 'react';
import cx from 'classnames';
import { useIntl } from 'react-intl';
import { marketImages } from '~helpers/marketImages';

import './style.scss';

const Wrapper = ({ children, className }) => {
  const intl = useIntl();
  const { picture, pictureWebp } = marketImages(intl.locale);

  return (
    <div className={cx('c-hero-hp', { [className]: !!className })}>
      <div className="c-hero-hp__inner">
        <div className={`c-hero-hp__background`}>
          <div className="c-hero-hp__gradient-overlay-old"></div>
            <picture className="c-hero-hp__img">
              <source type="image/webp" srcSet={pictureWebp.srcSet} />
              <img src={picture.src} srcSet={picture.srcSet} sizes="(max-width: 767px) 100vw, (max-width: 1600px) 100vw, 1600px" alt="" width="1774" height="887" fetchpriority="high" loading="eager" decoding="async" />
            </picture>
        </div>
          <div className="c-hero-hp__content">{children}</div>
      </div>
    </div>
  );
};


const Title = ({ children, className }) => {
  return (
    <div className={cx('c-hero-hp__title', { [className]: !!className })}>
      <h1 className="l-headline--primary">{children}</h1>
    </div>
  );
};
const Subtitle = ({ children, className }) => {
  return <div className={cx('c-hero-hp__subtitle', { [className]: !!className })}>{children}</div>;
};

const Ticks = ({ children, className }) => {
  return <div className={cx('c-hero-hp__ticks', { [className]: !!className })}>{children}</div>;
};

const Postcode = ({children}) => {
  return (
    <div className="c-hero-hp__srarch">
      <div className="search-filt">{children}</div>
    </div>
  );
};

const Intro = ({ children }) => {
  return <div className="c-hero-hp__intro">{children}</div>;
};

const Buttons = ({ children }) => {
  return <div className="c-hero-hp__buttons">{children}</div>;
};


export default {
  Wrapper,
  Title,    
  Intro,
  Postcode,
  Buttons,
  Subtitle,
  Ticks,
};